﻿import onReady from '../utils/onReady';
import * as ClassList from '../utils/classList';
import MapsApi from 'google-maps-api';
import triggerCustomEvent from '../utils/triggerCustomEvent';

/*global google*/
/*global searchdatastring*/


/**
 * Boilerplate class demonstrating basic construction.
 * You can expand from here, or find verbose examples in example.js.
 *
 * @param {HTMLElement} container
 * @constructor
 */
class MapsGoogle {

    /**
     * The constructor is fired once the class is instantiated.
     *
     * @param {HTMLElement} container
     */
    constructor(container) {
        this.data = {
            apiKey: "AIzaSyAClnGHpZhPC1ckRomu2pGJHZqn4QuOO8Q",
            requestUrl: "https://maps.googleapis.com/maps/api/place/nearbysearch/json?"
        };

        // Run initializing code once the DOM is ready.
        onReady(() => this.init(container));

        // You can put other initializer-code here if it isn't dependent on the DOM in any way.
    }

    /**
     * The actual initialization function, fired once the DOM is ready.
     *
     * @param {HTMLElement} container
     */
    init(container) {

        this.dom = {
            container // ES6 allows this syntax instead of writing "container: container"
        };

        this.addEvents();

        // Getting google maps api
        this.mapsApi = new MapsApi(this.data.apiKey, ['places']);
        this.mapsApi().then(maps => {
            this.mapsObject = maps;
            this.initMap();

            // Creating 1 infowindow, which will be moved from house to house, so that only 1 is active at a time
            this.infoWindow = new google.maps.InfoWindow();
            this.infoWindowDefault = new google.maps.InfoWindow();
            this.service = new google.maps.places.PlacesService(this.map);
            this.transitLayer = new google.maps.TransitLayer();
        });


        this.route = this.dom.container.dataset.route;
        this.linkType = this.dom.container.dataset.linkType;
        this.url = window.location.protocol + "//" + window.location.hostname + "/api/section" + this.route;

        this.colors = {
            white: "#FFFFFF",
            black: "#000000",
            red: "#c00000",
            blue: "#316491",
            green: "#00711c",
            yellow: "#f3ca40"
        };

        this.markers = {
            houses: [],
            schools: [],
            dayCares: [],
            stores: [],
            transits: []
        };

        this.styles = {
            default: [
                {
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#949494"
                        }
                    ]
                },
                {
                    "elementType": "labels",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "administrative",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "administrative.land_parcel",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "administrative.neighborhood",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "poi",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "road",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#ffffff"
                        }
                    ]
                },
                {
                    "featureType": "road",
                    "elementType": "labels.icon",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "road.arterial",
                    "elementType": "labels",
                    "stylers": [
                        {
                            "visibility": "on"
                        }
                    ]
                },
                {
                    "featureType": "road.arterial",
                    "elementType": "labels.icon",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "road.arterial",
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "color": "#949494"
                        }
                    ]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#ffffff"
                        }
                    ]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "labels",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "road.local",
                    "stylers": [
                        {
                            "visibility": "on"
                        }
                    ]
                },
                {
                    "featureType": "road.local",
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "color": "#9e9e9e"
                        }
                    ]
                },
                {
                    "featureType": "transit",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "transit.line",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "water",
                    "stylers": [
                        {
                            "color": "#3c5eff"
                        }
                    ]
                },
                {
                    "featureType": "water",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#254A6A"
                        }
                    ]
                },
                {
                    "featureType": "water",
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "color": "#9e9e9e"
                        }
                    ]
                }
            ],
            transit: [
                {
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#f5f5f5"
                        }
                    ]
                },
                {
                    "elementType": "labels",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "administrative",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "administrative.land_parcel",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "administrative.neighborhood",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "poi",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "road",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#ffffff"
                        }
                    ]
                },
                {
                    "featureType": "road",
                    "elementType": "labels.icon",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "road.arterial",
                    "elementType": "labels",
                    "stylers": [
                        {
                            "visibility": "on"
                        }
                    ]
                },
                {
                    "featureType": "road.arterial",
                    "elementType": "labels.icon",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "road.arterial",
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "color": "#949494"
                        }
                    ]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#dadada"
                        }
                    ]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "labels",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "road.local",
                    "stylers": [
                        {
                            "visibility": "on"
                        }
                    ]
                },
                {
                    "featureType": "road.local",
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "color": "#9e9e9e"
                        }
                    ]
                },
                {
                    "featureType": "transit",
                    "stylers": [
                        {
                            "visibility": "on"
                        }
                    ]
                },
                {
                    "featureType": "transit.line",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "visibility": "on"
                        },
                        {
                            "color": this.colors.yellow
                        },
                        {
                            "weight": 2
                        }

                    ]
                },
                {
                    "featureType": "transit.station",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#eeeeee"
                        }
                    ]
                },
                {
                    "featureType": "water",
                    "stylers": [
                        {
                            "color": "#3c5eff"
                        }
                    ]
                },
                {
                    "featureType": "water",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#336590"
                        }
                    ]
                },
                {
                    "featureType": "water",
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "color": "#9e9e9e"
                        }
                    ]
                }
            ]
        };

        // Put your other DOM-specific initializations here, and get your class moving!
    }

    prepareData(data) {

        let houseObj = data;

        houseObj.City = houseObj.Town;
        houseObj.Name = houseObj.SectionHeadline;
        houseObj.Zip = houseObj.Zip === null ? "" : houseObj.Zip;
        // houseObj.MoreInfoUrl = houseObj.newLink;

        return houseObj;
    }

    getData() {
        // Adding overlay while data is getting fetched
        ClassList.add(this.dom.container, "mapsGoogle--fetch");

        fetch(this.url)
            .then(this.handleResponse.bind(this))
            .then(data => this.addHouses(data))
            .catch(error => this.handleError(error));
    }

    handleError(error) {
        window.console.log("Catch: " + error);
        ClassList.add(this.dom.container, "mapsGoogle--error");
    }

    handleResponse(response) {
        // Removing overlay when data is fetched
        ClassList.remove(this.dom.container, "mapsGoogle--fetch");

        let contentType = response.headers.get('content-type');
        if (contentType.includes('application/json')) {
            return this.handleJSONResponse(response);
        } else if (contentType.includes('text/html')) {
            return this.handleTextResponse(response);
        } else {
            throw new Error(`Sorry, content-type ${contentType} not supported`);
        }
    }

    handleJSONResponse(response) {
        return response.json()
            .then(json => {
                if (response.ok) {
                    return json;
                } else {
                    return Promise.reject(Object.assign({}, json, {
                        status: response.status,
                        statusText: response.statusText
                    }));
                }
            });
    }

    handleTextResponse(response) {
        return response.text()
            .then(text => {
                if (response.ok) {
                    return text;
                } else {
                    return Promise.reject({
                        status: response.status,
                        statusText: response.statusText,
                        err: text
                    });
                }
            });
    }

    addHouses(data) {
        // Check if json is array or object. If object it's because there's only 1
        if(Array.isArray(data)) {
            data.forEach( element => {

                // If the data is embedded in the page, the json is different, and we need to process that
                if (this.embeddedFlag) {
                    this.addMarker(this.prepareData(element));
                } else {
                    this.addMarker(element);
                }
            });

            if (data.length === 1) {
                this.map.panTo(data[0].Coordinate);
                this.map.setZoom(13);
            } else if (data.length > 1) {
                this.fitMapToBounds();
            }
        } else {
            // for (let key in data) {
            //     if (data.hasOwnProperty(key)) {
            //         this.addMarker(data);
            //     }
            // }
            this.addMarker(data);

            this.map.panTo(data.Coordinate);
            this.map.setZoom(13);
        }
    }

    addMarker(house) {
        let hideButtonClass = "",
            buttonText = "Gå til afdelingen";

        this.icons.houses.fillColor = this.colors[house.AvailabilityColor];

        // Non strict comparison, since it might be undefined or null
        // If we are on searchPage, linkType data-attribute is not set and we do not modify url or button
        if (this.linkType == "showSection") {

            // If we are on a localsite, there is no WebsiteUrl,
            if ( house.WebsiteUrl != null) {
                house.MoreInfoUrl = house.WebsiteUrl;
                buttonText = "gå til afdelingshjemmesiden";
            } else {
                hideButtonClass = 'class="hidden"';
            }
        } else if (this.linkType == "mapAsBox") {
            // If the map is not the map on searchPage or showSection, like a map on the frontpage of a local page, then button links to the localpage's showSection

            house.MoreInfoUrl = "/boliger";
            buttonText = "Gå til boligvisning";
        }

        let infoWindowContent =
            `
            <div class="infoWindow">
                <div class="infoWindow__content">
                    <div class="infoWindow__image">
                        <img src=${house.ImageUrl}>
                    </div>
                    <div class="infoWindow__info">
                        <h4 class="box__headline box__headline--no-margin">${house.Name}</h4>
                        <p class="box__text box__text--no-margin">${house.Address}</p>
                        <p class="box__text box__text--no-margin">${house.Zip} ${house.City}</p>
                        <p class="availability-dot availability-dot--${house.AvailabilityColor}">Ventetid: ${house.AvailabilityText}</p>
                    </div>
                </div>
                <a href="${house.MoreInfoUrl}" ${hideButtonClass}>
                    <div class="button button--auto-width">
                        <div class="button__text">${buttonText}</div>
                    </div>
                </a>
            </div>
            `;

        let marker = new google.maps.Marker({
            position: house.Coordinate,
            icon: this.icons.houses,
            map: this.map,
            title: house.Name
        });

        marker.addListener("click", () => {
            // Closing default infowindow to avoid targeting this window for removing of elements
            this.infoWindowDefault.close();
            this.infoWindow.setContent(infoWindowContent);
            this.infoWindow.open(this.map, marker);
        });

        this.markers.houses.push(marker);
        if (house.Coordinate.lat !== 0 && house.Coordinate.lng !== 0) {
            this.bounds.extend(house.Coordinate);
        }
    }

    addEvents() {
        this.dom.container.parentNode.addEventListener('nearby-search--on', (event) => this.nearbySearchAdd(event));
        this.dom.container.parentNode.addEventListener('nearby-search--off', (event) => this.nearbySearchRemove(event));
    }

    nearbySearchAdd(event) {

        // Adding overlay to show data is being fetched
        ClassList.add(this.dom.container, "mapsGoogle--fetch");

        // Using .target and .srcElement for crossbrowser support
        this.target = event.target || event.srcElement;

        this.searchName = this.target.dataset.searchName;

        if (this.searchName === "transits") {
            this.transitLayer.setMap(this.map);
            //this.map.setOptions({styles: this.styles.transit});

            // Remove overlay when all data is retrieved
            ClassList.remove(this.dom.container, "mapsGoogle--fetch");

            // Trigger custom event that reenables buttons
            triggerCustomEvent(this.dom.container, "enable-buttons");

            return;
        }

        this.request = {
            location: this.map.getCenter(),
            radius: 2000,
            type: [this.target.dataset.searchType],
            keyword: this.target.dataset.searchKeyword
        };

        this.service.nearbySearch(this.request, this.handleResults.bind(this));
    }

    nearbySearchRemove(event) {
        // Using .target and .srcElement for crossbrowser support
        this.target = event.target || event.srcElement;
        this.searchName = this.target.dataset.searchName;

        if (this.searchName === "transits") {
            this.transitLayer.setMap(null);
            //this.map.setOptions({styles: this.styles['default']});
        }

        this.clearMarkers();
    }

    clearMarkers() {
        this.markers[this.searchName].forEach( element => {
            element.setMap(null);
        });

        this.markers[this.searchName] = [];
    }

    handleResults(results, status, pagination) {
        if (status === google.maps.places.PlacesServiceStatus.OK) {

            for (let i = 0; i < results.length; i += 1) {
                this.createMarker(results[i]);
            }

            // If more search results than 20 exists, display those (Limited to 60 by Google + 2s delay between each new page)
            if (pagination.hasNextPage) {
                pagination.nextPage();

            } else {
                // Remove overlay when all data is retrieved
                ClassList.remove(this.dom.container, "mapsGoogle--fetch");

                // Trigger custom event that reenables buttons
                triggerCustomEvent(this.dom.container, "enable-buttons");
            }

        } else {
            // Remove overlay if no data
            ClassList.remove(this.dom.container, "mapsGoogle--fetch");

            // Trigger custom event that reenables buttons
            triggerCustomEvent(this.dom.container, "enable-buttons");
            triggerCustomEvent(this.target, "remove-active");
        }
    }

    createMarker(place) {
        let placeLoc = place.geometry.location;
        let marker = new google.maps.Marker({
            icon: this.icons[this.searchName],
            map: this.map,
            position: placeLoc
        });

        this.markers[this.searchName].push(marker);

        google.maps.event.addListener(marker, 'click', () => {
            // Closing house infowindow
            this.infoWindow.close();
            this.infoWindowDefault.setContent(place.name);
            this.infoWindowDefault.open(this.map, marker);
        });
    }

    fitMapToBounds() {
        this.map.fitBounds(this.bounds);

        // If fitBounds zooms too much, set zoom to 13
        google.maps.event.addListenerOnce(this.map, 'bounds_changed', () => {
            if(this.map.getZoom() > 13){
                this.map.setZoom(13);
            }
        });
    }

    initMap() {
        let mapOptions = {
            zoom: 6,
            // gestureHandling: "cooperative", // Why wont you work?
            scrollwheel: false, // Using this for now then
            streetViewControl: false,
            rotateControl: false,
            mapTypeControl: false,
            center: {lat: 56.162939, lng: 10.203921000000037},
            zoomControl: true,
            zoomControlOptions: {
                position: google.maps.ControlPosition.LEFT_TOP
            }
        };

        this.map = new this.mapsObject.Map(this.dom.container, mapOptions);
        this.bounds = new google.maps.LatLngBounds();


        this.icons = {
            houses: {
                path: "M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z",
                fillColor: "",
                fillOpacity: 1,
                strokeWeight: 2,
                strokeColor: this.colors.white,
                scale: 1.8,
                size: new google.maps.Size(20, 17),
                scaledSize: new google.maps.Size(37, 31),
                origin: new google.maps.Point(0, 0),
                anchor: new google.maps.Point(15, 13)
            },
            schools: {
                path: "M5 13.18v4L12 21l7-3.82v-4L12 17l-7-3.82zM12 3L1 9l11 6 9-4.91V17h2V9L12 3z",
                fillColor: this.colors.blue,
                fillOpacity: 1,
                strokeWeight: 0
            },
            stores: {
                path: "M7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zM1 2v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.14 0-.25-.11-.25-.25l.03-.12.9-1.63h7.45c.75 0 1.41-.41 1.75-1.03l3.58-6.49c.08-.14.12-.31.12-.48 0-.55-.45-1-1-1H5.21l-.94-2H1zm16 16c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2z",
                fillColor: this.colors.green,
                fillOpacity: 1,
                strokeWeight: 0
            },
            transits: {
                path: "M18.92 6.01C18.72 5.42 18.16 5 17.5 5h-11c-.66 0-1.21.42-1.42 1.01L3 12v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.5 16c-.83 0-1.5-.67-1.5-1.5S5.67 13 6.5 13s1.5.67 1.5 1.5S7.33 16 6.5 16zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5 11l1.5-4.5h11L19 11H5z",
                fillColor: this.colors.red,
                fillOpacity: 1,
                strokeWeight: 0
            }
        };


        if (this.route !== "") {
            // Getting houses
            this.getData();
        } else {
            this.embeddedFlag = 1;

            // searchdatastring is from embedded JSON
            this.addHouses(searchdatastring);
        }
    }

}


export default MapsGoogle;